module.exports = __webpack_public_path__ + "static/hinge-2619cbf542490372ff2354f465f14349.png";